<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2> 
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fecha }}</h4> 
            </div>
            <div class="col-md-2 d-flex justify-content-start pl-0">
                <input type="month" :items="fecha" class="form-control" style="width: 180px;">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consultaReporte">{{ labels.consultar }}</b-button> 
        </div>
        <div class="col-md-12 mt-3">
            <div v-if="btnGenExcel" class="row col-md-12 align-items-center d-flex justify-content-end">
                <b-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaReporte()">
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg> 
                    </i>
                </b-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="lstReporte != 0">
                <b-table md-card md-header v-if="lstReporte?.length"> 
                    <b-table-row slot="b-table-head">
                        <b-table-head
                        v-for="col in dynamicColumns"
                        :key="col"
                        >
                        {{ formatColumn(col) }}
                        </b-table-head>
                    </b-table-row>

                    <b-table-row
                        v-for="(item, index) in lstReporte"
                        :key="index"
                        @click="cargaDetalle(item)"
                    >
                        <b-table-cell
                        v-for="col in dynamicColumns"
                        :key="col"
                        class="border"
                        >
                        {{ formatValue(item[col], col) }}
                        </b-table-cell>
                    </b-table-row>
                </b-table>
            </div>
        </div>
        <ModDetalleReporte :modDetReport="showModDetReport" :infoDet="detallReport" @cierraModal="closeModal()"></ModDetalleReporte>
    </div>
</template>

<script>
import * as XLSX from "exceljs";
import Reportes from '../../services/Reportes'; 
import ModDetalleReporte from './ModDetalleReporte.vue'; 

export default {
    name : 'ReporteContratos',
    components : {ModDetalleReporte},
    data : () => ({
        fecha : '',
        lstReporte : [],
        dynamicColumns: [],
        btnGenExcel : false,
        showModDetReport : false,
        detallReport : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Reporte contratos',
                    fecha : 'Fecha:',
                    consultar : 'Consultar',
                    nroContrato : 'Contrato',
                    proveedor : 'Proveedor',
                }
            }else{
                return {
                    title : 'Contract report',
                    fecha : 'Date:',
                    consultar : 'Consult',
                    nroContrato : 'Contract',
                    proveedor : 'Provider',
                }
            }
        }
    },
    methods : {
        closeModal(){
            this.showModDetReport = false 
        },
        // consultaReporte(){
        // if(this.fecha != ''){ 

        // Reportes.getComparativoTrimestral(this.fecha) 
        // .then((res) => { 
        // console.log(res.data.listaReporte); 
        // this.lstReporte = res.data.listaReporte 
        //         })
        // .catch((err) => console.log(err)) 
        //     }else{
        // this.$toast.error('Diligenciar la fecha.') 
        //     }
        // }

        consultaReporte() {
            if (this.fecha != '') { 
                Reportes.getComparativoTrimestral(this.fecha) 
                .then((res) => { 
                    const data = res.data.listaReporte; 
                    this.lstReporte = data; 
                    // console.log(this.lstReporte); 

                    if (data.length > 0) { 
                        const allCols = Object.keys(data[0]); 
                        const fixedCols = ['nro_contrato', 'proveedor']; // siempre van primero
                        const dynamicCols = allCols.filter(c => !fixedCols.includes(c)); 

                        this.dynamicColumns = [...fixedCols, ...dynamicCols]; 

                        this.btnGenExcel = true 
                    
                    }else{
                        this.btnGenExcel = false 
                        this.$toast.error('No hay registros para la fecha seleccionada.'); 
                    }
                })
                .catch((err) => console.log(err)); 
            } else {
                this.$toast.error('Diligenciar la fecha.'); 
            }
        },
        formatColumn(col) {
            // Ej: activo_2023_06 → Activo 2023-06
            return col
            .replace(/_/g, ' ') 
            .replace(/(\d{4}) (\d{2})/, '$1-$2') 
            .replace(/\b\w/g, l => l.toUpperCase()); 
        },

        formatValue(val) {
            // Si es numérico, aplicar formato de moneda
            if (typeof val === 'number') {
            return new Intl.NumberFormat('es-CO', { 
                minimumFractionDigits: 0,
                maximumFractionDigits: 3
            }).format(val); 
            }

            return val ?? 0;
        },
        async generaReporte(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Reporte "+this.fecha) 

            const titulo = ["Reporte "+this.fecha] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:S1') 
            worksheet.getCell('A1').font = { bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            worksheet.addRow(this.dynamicColumns) 
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = { 
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.lstReporte.forEach((item) => { 
                const fila = this.dynamicColumns.map(col => { 
                    const val = item[col];
                    return typeof val === 'string' && !isNaN(val) ? parseFloat(val) : val;
                });
                worksheet.addRow(fila); 
            });

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){ 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Reporte "+this.fecha+".xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        },
        cargaDetalle(info){
            
            Reportes.getComparativoTrimestralPorContract(this.fecha,info.nro_contrato) 
            .then((res) => { 
                // console.log(res.data.listaReportByCont); 
                this.detallReport = res.data.listaReportByCont 
                this.showModDetReport = true 
            })
            .catch((err) => console.log(err)) 
        }
    }
}
</script>

<style>

</style>
